import angular from 'angular';

let CardDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Card) {
  let $ctrl = this;

  const daysPerYear = 365;
  const monthsPerYear = 30.4167;

  $ctrl.id = $state.params.id;
  $ctrl.card;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete
  });

  activate();

  function activate() {
    clearForm();

    loadResource($ctrl.id);
  }

  function clearForm(form) {
    $ctrl.card = {
      input_interval_unit: 'MONTHS'
    };

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(card, event) {
    let confirmMessage = 'common-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Card
          .destroy(card)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('card.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, card) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    let multiplier = card.input_interval_unit === 'MONTHS' ? monthsPerYear : daysPerYear;
    card.interval_in_days = Math.round($ctrl.intervalValue * multiplier);

    save(card);
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Card.show(id)
        .then(response => {
          response.input_interval_unit = response.input_interval_unit || 'MONTHS';
          let multiplier = response.input_interval_unit === 'MONTHS' ? monthsPerYear : daysPerYear;
          $ctrl.intervalValue = Math.round(response.interval_in_days / multiplier);

          $ctrl.card = response;
          $ctrl.card.doses = response.doses === 0 ? 'Anual' : response.doses;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(card) {
    $ctrl.saving = true;

    Card
      .save(card)
      .then(response => {
        Toast.success($filter('translate')('card-detail-save-success'));
        $ctrl.card = response;
        $ctrl.saving = false;
        $state.go('card.list');
      })
      .catch(err => {
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'card-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

CardDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Card'];

export default CardDetailController;



// WEBPACK FOOTER //
// ./client/app/components/card/card-detail.controller.js